import adresApi from "../../api/adresApi";

export default class AdresHelper {
	constructor(context, customModelName) {
		this.context = context;
		this.modelName = customModelName ? customModelName : 'editingAdres';
	}

	editNewAdres(callback) {
		const ajaxActions = this.context.props.ajaxActions;
		ajaxActions.started();
		adresApi.create().then(response => {
			ajaxActions.ended();
			this.context.setState({
				[this.modelName]: response.data
			});

			if (callback) callback();
		});
	}

	editAdres(adresToEdit) {
		if (!adresToEdit.internationaalAdres) {
			let item = this.context.props.postcodeGemeenten.find(x => x.value === adresToEdit.postcode + " - " + adresToEdit.gemeente);

			if (!item) {
				item = this.context.props.postcodeGemeenten.find(x => x.customValue.postcode === adresToEdit.postcode);
			}

			adresToEdit.postcodeGemeente = item ? item.value : "";
		}
		this.loadStraten(adresToEdit.postcode);

		this.context.setState({
			[this.modelName]: adresToEdit
		});
	}

	changeAdresField(property, value) {
		let fieldFound = false;
		const context = this.context;
		const state = context.state;

		const model = context.state[this.modelName];
		const originalModel = state.originalModel ? state.originalModel.adressen.find(a => a.id === model.id) : null;

		switch (property) {
			case "land":
				fieldFound = true;
				if (model.land !== value) {
					model.postcode = null;
					model.gemeente = null;
					model.postcodeGemeente = null;
					model.nisCodeGemeente = null;
					model.straatId = null;
					model.straat = '';
					model.huisnummerId = null;
					model.huisnummer = '';
					model.busnummerId = null;
					model.busnummer = '';
					model.internationaalAdres = '';

					model.land = value;
				}
				break;
			case "postcodeGemeente":
				fieldFound = true;
				if (model.postcodeGemeente !== value) {
					const item = context.props.postcodeGemeenten.find(x => x.value === value);
					if (item) {
						this.loadStraten(item.customValue.postcode);

						model.postcodeGemeente = item.value;
						model.postcode = item.customValue.postcode;
						model.gemeente = item.customValue.gemeente;
						model.nisCodeGemeente = item.customValue.nisCode;
					}
					else {
						model.postcodeGemeente = '';
						model.postcode = '';
						model.gemeente = '';
						model.nisCodeGemeente = null;
					}

					model.straat = '';
					model.straatId = null;
					model.huisnummerId = null;
					model.huisnummer = '';
					model.busnummerId = null;
					model.busnummer = '';

					this.context.setState({
						straten: [],
						huisnummers: null,
						busnummers: null
					});
				}
				break;
			case "straat":
				fieldFound = true;
				if (model.straat !== value) {
					model.huisnummerId = null;
					model.huisnummer = '';
					model.busnummerId = null;
					model.busnummer = '';

					const straten = context.state.straten;
					let foundStraat = straten.find(x => x.value === value);
					foundStraat = foundStraat || straten.find(x => x.label.toLowerCase() === value.toLowerCase());

					if (foundStraat) {
						this.context.setState({
							huisnummers: null,
							busnummers: null
						});
						model.straatId = foundStraat.value;
						model.straat = foundStraat.label;
					} else {
						this.context.setState({
							huisnummers: value ? [] : null,
							busnummers: value ? [] : null
						});
						model.straatId = null;
						model.straat = value;
					}
				}
				break;
			case "huisnummer":
				fieldFound = true;
				if (model.huisnummer !== value) {
					model.busnummerId = null;
					model.busnummer = '';

					this.context.setState({
						huisnummers: value ? [] : null,
						busnummers: value ? [] : null
					});
					model.huisnummerId = null;
					model.huisnummer = value;
				}
				break;
			case "busnummer":
				fieldFound = true;
				if (model.busnummer !== value) {
					this.context.setState({
						busnummers: value ? [] : null
					});
					model.busnummerId = null;
					model.busnummer = value;
				}
				break;
			case "internationaalAdres":
				fieldFound = true;
				if (model.internationaalAdres !== value) {
					model.internationaalAdres = value;
				}
				break;
			default:
				fieldFound = false;
				break;
		}

		if (originalModel) {
			model.isChanged = originalModel && (originalModel[property] != value);
		}

		this.context.setState({
			[this.modelName]: model
		});

		return fieldFound;
	}

	loadStraten = (postcode) => {
		const context = this.context;

		if (!postcode) {
			context.setState({ straten: [] });
			return;
		}

		context.setState({ stratenLoading: true });
		adresApi.getStraten(postcode)
			.then((response) => {
				let uniekeStraten = [];
				response.data.forEach(s => {
					if (!uniekeStraten.find(x => x.straatId === s.straatId || x.naam === s.naam))
						uniekeStraten.push(s);
				});
				context.setState({
					stratenLoading: false,
					straten: uniekeStraten.map(e => { return { label: e.naam, value: e.straatId }; })
				});
			})
			.catch((ex) => {
				alert("getStraten Error");
			});
	};
}
